<template>
	<div class="rating">
		<svgicon
			v-for="(n, index) in maxRating"
			:key="index"
			class="star"
			:rating="rating"
			:original="true"
			:class="bindConditional(index + 1)"
			:name="bindConditional(index + 1)"
		></svgicon>
	</div>
</template>
<script>
import '../icons/star-outline';
import '../icons/star-full';

export default {
	props: {
		rating: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			maxRating: 5,
			name: String
		};
	},
	methods: {
		bindConditional(index) {
			return Math.round(this.rating) >= index ? 'star-full' : 'star-outline';
		}
	}
};
</script>
<style lang="scss" scoped>
.rating {
	height: 24px;
	width: 152px;
	margin: auto;
	display: flex;
	justify-content: space-around;
}
.star {
	height: 16.36px;
	width: 17.11px;
}
.star-outline {
	background-image: url('../icons/star-outline');
}
</style>
